/**
 * Meta's template statuses, translated for the CRM.
 *
 * Deliberately a lookup with a fallback rather than an exhaustive union: Meta
 * owns this vocabulary and adds to it, and a status we have never seen must
 * still render — showing the raw value is worse than nothing only if nothing is
 * the alternative, and here the alternative is a blank cell on a template the
 * school cannot send.
 */
const LABELS: Record<string, string> = {
  draft: "Borrador",
  PENDING: "En revisión",
  APPROVED: "Aprobada",
  REJECTED: "Rechazada",
  PAUSED: "Pausada",
  DISABLED: "Deshabilitada",
  FLAGGED: "Marcada",
  IN_APPEAL: "En apelación",
  LIMIT_EXCEEDED: "Límite excedido",
  LOCKED: "Bloqueada",
  PENDING_DELETION: "Pendiente de borrado",
  DELETED: "Eliminada",
  ARCHIVED: "Archivada en Meta",
  UNARCHIVED: "Restaurada en Meta",
  REINSTATED: "Restablecida",
};

export type StatusTone = "neutral" | "pending" | "good" | "warn" | "bad";

const TONES: Record<string, StatusTone> = {
  draft: "neutral",
  PENDING: "pending",
  APPROVED: "good",
  REINSTATED: "good",
  UNARCHIVED: "good",
  REJECTED: "bad",
  DISABLED: "bad",
  DELETED: "bad",
  PENDING_DELETION: "bad",
  PAUSED: "warn",
  FLAGGED: "warn",
  IN_APPEAL: "warn",
  LIMIT_EXCEEDED: "warn",
  LOCKED: "warn",
  ARCHIVED: "neutral",
};

export function statusLabel(status: string): string {
  return LABELS[status] ?? status;
}

export function statusTone(status: string): StatusTone {
  return TONES[status] ?? "neutral";
}

/** Only an approved template can actually be sent. */
export function isSendable(status: string): boolean {
  return status === "APPROVED";
}

const QUALITY_LABELS: Record<string, string> = {
  GREEN: "Calidad alta",
  YELLOW: "Calidad media",
  RED: "Calidad baja",
  UNKNOWN: "Calidad sin datos",
};

export function qualityLabel(score: string): string {
  return QUALITY_LABELS[score] ?? score;
}
